import React, { createContext, useContext, useState } from 'react';

const LanguageContext = createContext();

export const translations = {
  tr: {
    nav: {
      home: 'Ana Sayfa',
      about: 'Hakkımızda',
      products: 'Ürünler',
      forms: 'Bilgi Formları',
      contact: 'İletişim',
      contactBtn: 'İletişime Geç',
    },
    hero: {
      slide1: 'Minik dostlarınız İçin yüksek standartlarda destek ürünleri geliştiriyoruz.',
      slide1highlight: 'yüksek',
      slide2h1: 'En İyi',
      slide2h2: 'ürünler',
      slide2h3: 'En İyi',
      slide2h4: 'Dostunuz İçin',
      slide2p: 'Onlar için en iyisini sunuyoruz.',
      btn: 'Hakkımızda',
    },
    about2: {
      heading1: 'Tutkumuz',
      heading2: 'Evcil Dostlarımızın',
      heading3: 'sağlığını korumak ve desteklemek.',
      p1: 'Vitanimal olarak, evcil hayvanlarınızın sağlığı ve mutluluğu için çalışıyoruz. Onların ihtiyaç duyduğu en kaliteli ürünleri sunmaktan gurur duyuyoruz.',
      p2: 'Uzman ekibimiz ve geniş ürün yelpazemizle, can dostlarınızın her zaman yanındayız. Onların sağlığı bizim için her şeyden önemli.',
      customers: '3b+ Müşteri',
      phone: 'Telefon:',
    },
    getquate: {
      heading1: 'Onların dünyasını',
      heading2: 'sevgiyle',
      heading3: 'sarıyor,',
      heading4: 'şefkatle',
      heading5: 'onarıyoruz.',
      p: 'Can dostlarınız için en iyisini sağlayarak, onların hayatını ve sizin hayatınızı daha da güzelleştirmeyi hedefliyoruz.',
      li1: 'Veteriner Hekim Onaylı Formülasyonlar',
      li2: 'Kontrollü üretim süreçleri ve titizlikle seçilen içerikler',
      li3: 'Klinik verilerle geliştirilen, güvenilir ve etkili çözümler.',
      badge: 'Can Dostunuz İçin En İyi Sağlık Çözümleri',
    },
    about: {
      subtitle: 'Hakkımızda',
      title: 'Vitanimal',
      badgeTitle: '42ler',
      badgeText: 'Bilimsel araştırmalar ve veteriner hekimlerin rehberliğinde, kedilerin özgün biyolojik ihtiyaçlarına uygun formüller oluşturuyor ve güvenilir çözümler sunuyoruz.',
      p1: "pet hayvanlarının sağlığı ve yaşam kalitesini en üst seviyeye taşımak amacıyla ilaç, mineral, vitamin ve yem katkı ürünleri sunan, 42ler Pharma tarafından geliştirilen yenilikçi bir ürün grubudur. Bilimsel araştırmalar ve veteriner hekimlerin rehberliğinde, pet hayvanlarının özgün biyolojik ihtiyaçlarına uygun formüller oluşturuyor ve güvenilir çözümler sunuyoruz.",
      p2: "Uzman ekibimiz, Ar-Ge çalışmalarında en güncel bilimsel verileri ve yenilikçi teknolojileri kullanarak ürünlerimizi geliştirir. Her ürünümüz, pet hayvanlarının sağlıklı bir yaşam sürmesini destekleyecek şekilde tasarlanır ve uluslararası kalite standartlarına uygun olarak üretilir.",
      p3: "Bağışıklık sistemini güçlendiren vitamin takviyelerinden, metabolizmayı destekleyen minerallere ve özel tedavi gerektiren durumlar için geliştirilen ilaçlara kadar geniş bir ürün yelpazesi sunuyoruz. Tüm üretim süreçlerimizde pet refahını ön planda tutarak etik ve sürdürülebilir yaklaşımlar benimsiyoruz.",
      p4: "Vitanimal olarak hedefimiz, pet hayvanlarının sağlıklı, mutlu ve enerjik bir yaşam sürmesini sağlamak ve sahiplerine güvenilir ürünler sunarak aralarındaki bağı güçlendirmektir. Bilimsel ışığında, doğanın dengesine saygı duyarak tüm pet hayvanları için en iyisini sunmaya devam ediyoruz.",
    },
    footer: {
      tagline: 'Veteriner bilimiyle formule edildi',
      social: 'Sosyal',
      contact: 'iletişim',
      quickLinks: 'Hızlı Linkler',
      home: 'Ana Sayfa',
      about: 'Hakkımızda',
      products: 'Ürünler',
      contactLink: 'İletişim',
      privacy: 'Gizlilik Politikası',
      terms: 'Sorumluluk Reddi',
    },
    contact: {
      hours: 'Çalışma Saatleri',
      hoursVal: 'Pazartesi-Cuma :08:00 - 19:00',
      email: 'E-posta',
      call: 'Bizi Arayın',
      formTitle: 'Bir Sorunuz Mu Var?',
      formDesc: 'Uzman ekibimiz sorularınızı yanıtlamak için hazır. Bize ulaşmaktan çekinmeyin.',
      namePlaceholder: 'Adınız',
      emailPlaceholder: 'E-posta Adresiniz',
      phonePlaceholder: 'Telefon Numaranız',
      subjectPlaceholder: 'Konu',
      messagePlaceholder: 'Mesajınız',
      submitBtn: 'Mesaj Gönder',
      nameReq: 'Ad alanı zorunludur.',
      emailReq: 'E-posta adresi boş bırakılamaz.',
      emailInvalid: 'Geçersiz e-posta formatı.',
      phoneReq: 'Telefon numarası gereklidir.',
      subjectReq: 'Lütfen bir konu giriniz.',
      messageReq: 'Lütfen mesajınızı buraya yazın.',
      success: 'Mesajınız başarıyla gönderildi!',
      error: 'Mesaj gönderilirken bir hata oluştu. Lütfen tekrar deneyin.',
    },
    product: {
      backBtn: 'Tüm Ürünlere Dön',
      whatsapp: 'WhatsApp ile Bilgi Al',
      brand: 'Marka:',
      size: 'Boyut:',
      tabFeatures: 'Ürün Özellikleri',
      tabUsage: 'Kullanım Talimatları',
      tabPdf: 'Bilgi Formu',
      composition: 'Bileşimi',
      ingredients: 'Etken Maddeler ve Faydaları',
      usageArea: 'Kullanım Alanı',
      usageInstructions: 'Kullanım Talimatları',
      dosage: 'Dozaj Tablosu',
      storage: 'Saklama Koşulları',
      noUsage: 'Kullanım talimatları için ürün ambalajına bakınız veya veteriner hekiminize danışınız.',
    },
    pages: {
      about: 'Hakkımızda',
      products: 'Ürünler',
      forms: 'Bilgi Formları',
      contact: 'İletişim',
      home: 'Ana Sayfa',
      privacy: 'Gizlilik Politikası',
      terms: 'Sorumluluk Reddi',
    },
    error404: {
      title: 'Eyvah! Sayfa Bulunamadı!',
      desc: 'Üzgünüz, aradığınız sayfayı bulamıyoruz. Adresi yanlış yazmış olabilirsiniz.',
      btn: 'Ana Sayfaya Dön',
    },
    funfact: {
      products: 'Ürün',
      customers: 'Mutlu Müşteri',
      team: 'Takım Üyesi',
      protection: 'Koruma',
      customersUnit: 'b',
    },
    shop: {
      viewDetail: 'Detaylı Gör',
    },
    forms: {
      viewPdf: 'PDF Görüntüle',
    },
    terms: {
      title: 'Sorumluluk Reddi',
      h1: 'Bilgilendirme Amaçlı İçerik',
      p1: 'Bu web sitesinde sunulan bilgiler yalnızca genel bilgi ve eğitim amaçlıdır. Evcil hayvan besin takviyelerinin kullanımıyla ilgili kararlar alırken bir veteriner hekime danışmanız önerilir. Bu sitedeki ürün açıklamaları, herhangi bir hastalığı teşhis, tedavi veya önlemek amacıyla sunulmamaktadır.',
      h2: 'Ürün Kullanımı ve Etkileri',
      p2: 'Satılan besin takviyelerinin etkileri, her hayvanda farklılık gösterebilir. Ürünleri kullanmadan önce, ürün üzerindeki talimatları dikkatlice okuyunuz ve önerilen dozajlara uyunuz. Ürün kullanımından kaynaklanan herhangi bir olumsuz durumda sorumluluk tamamen kullanıcıya aittir.',
      h3: 'Veteriner Tavsiyesi Yerine Geçmez',
      p3: 'Bu sitedeki içerik ve ürünler, profesyonel bir veteriner tavsiyesinin yerine geçmez. Evcil hayvanınızın özel sağlık durumu hakkında doğru kararları vermek için mutlaka bir veteriner hekime danışın.',
      h4: 'Üçüncü Taraf Bilgiler ve Ürünler',
      p4: 'Web sitemizde sunulan ürünler, üçüncü taraf üreticiler tarafından sağlanmaktadır. Ürünlerin kalitesi ve güvenilirliği konusunda özen gösterilmesine rağmen, üretici firmaların sorumluluğundaki herhangi bir problemden dolayı sorumluluk kabul edilmez.',
      h5: 'Sorumluluk Sınırlandırılması',
      p5: 'Web sitemizi kullanarak, ürünlerin kullanımıyla ilgili tüm sorumluluğun size ait olduğunu kabul etmiş olursunuz. Web sitesi sahibi, ürünlerin yanlış kullanımından, beklenmeyen etkilerden veya herhangi bir zarardan sorumlu tutulamaz.',
      h6: 'Yasal Uyarılar',
      p6: 'Bu sitede satılan ürünler, yerel düzenlemelere uygun şekilde sunulmaktadır. Ürünlerin ithalatı veya kullanımıyla ilgili kendi bölgenizdeki yasalara uymanız sizin sorumluluğunuzdadır.',
    },
    privacy: {
      title: 'Gizlilik Politikası',
      h1: '1. Toplanan Bilgiler',
      p1_1: 'Kişisel Bilgiler: Ad, soyad, e-posta adresi, telefon numarası, teslimat adresi gibi müşterilerden toplanabilecek bilgiler.',
      p1_2: 'Otomatik Olarak Toplanan Bilgiler: IP adresi, tarayıcı türü, ziyaret edilen sayfalar, ziyaret süresi ve tarihleri gibi web sitesi kullanımıyla ilgili veriler.',
      h2: '2. Bilgilerin Kullanımı',
      p2: 'Toplanan kişisel veriler şu amaçlarla kullanılabilir:',
      li2_1: 'Siparişlerin işlenmesi ve teslimatı.',
      li2_2: 'Müşteri desteği sağlanması.',
      li2_3: 'Web sitesinin iyileştirilmesi ve kişiselleştirilmesi.',
      li2_4: 'Yasal yükümlülüklerin yerine getirilmesi.',
      li2_5: 'Müşteri onayı alındığında pazarlama ve promosyon faaliyetleri.',
      h3: '3. Çerezler (Cookies)',
      p3: 'Web siteniz, kullanıcı deneyimini geliştirmek için çerezler kullanabilir. Kullanıcılar, tarayıcı ayarlarından çerezlerin kullanımını kontrol edebilir ve yönetebilir.',
      h4: '4. Bilgilerin Paylaşımı',
      p4: 'Kişisel bilgiler, aşağıdaki durumlar dışında üçüncü taraflarla paylaşılmayacaktır:',
      li4_1: 'Yasal zorunluluklar.',
      li4_2: 'Hizmet sağlayıcılarla (örneğin, ödeme işlemcileri, lojistik firmaları) iş süreçlerinin yürütülmesi için gerekli olduğunda.',
      li4_3: 'Kullanıcının açık rızası alındığında.',
      h5: '5. Bilgilerin Korunması',
      p5: 'Kişisel verilerin güvenliği için uygun teknik ve idari önlemler alınmalıdır. Ancak, internet üzerinden yapılan veri iletimlerinin tamamen güvenli olduğu garanti edilemez.',
      h6: '6. Diğer Web Sitelerine Bağlantılar',
      p6: 'Web siteniz, diğer sitelere bağlantılar içerebilir. Bu sitelerin gizlilik uygulamalarından sorumlu olmadığınızı belirtmek önemlidir.',
      h7: '7. Çocukların Gizliliği',
      p7: 'Hizmetleriniz, 13 yaşın altındaki çocuklara yönelik değilse, bu durumu ve bu yaş grubundan bilerek bilgi toplanmadığını belirtmelisiniz.',
      h8: '8. Politika Değişiklikleri',
      p8: 'Gizlilik politikasında yapılacak değişikliklerin bu sayfada güncelleneceğini ve kullanıcıların periyodik olarak politikayı gözden geçirmelerinin önerildiğini ifade edin.',
      h9: '9. İletişim',
      p9: 'Gizlilik politikasıyla ilgili sorular için iletişim bilgilerinizi sağlayın.',
    },
  },

  en: {
    nav: {
      home: 'Home',
      about: 'About Us',
      products: 'Products',
      forms: 'Info Forms',
      contact: 'Contact',
      contactBtn: 'Get in Touch',
    },
    hero: {
      slide1: 'We develop high-standard support products for your little companions.',
      slide1highlight: 'high-standard',
      slide2h1: 'The Best',
      slide2h2: 'products',
      slide2h3: 'for Your',
      slide2h4: 'Best Friend',
      slide2p: 'We offer the best for them.',
      btn: 'About Us',
    },
    about2: {
      heading1: 'Our passion is to',
      heading2: 'protect and support',
      heading3: "the health of our pets.",
      p1: 'At Vitanimal, we work for the health and happiness of your pets. We are proud to offer the highest quality products they need.',
      p2: 'With our expert team and wide product range, we are always by the side of your beloved companions. Their health is everything to us.',
      customers: '3k+ Customers',
      phone: 'Phone:',
    },
    getquate: {
      heading1: 'We wrap their world with',
      heading2: 'love',
      heading3: 'and heal it with',
      heading4: 'compassion',
      heading5: '.',
      p: 'By providing the best for your beloved companions, we aim to make their lives and yours even more beautiful.',
      li1: 'Veterinarian-Approved Formulations',
      li2: 'Controlled production processes with carefully selected ingredients',
      li3: 'Reliable and effective solutions developed with clinical data.',
      badge: 'The Best Health Solutions for Your Companion',
    },
    about: {
      subtitle: 'About Us',
      title: 'Vitanimal',
      badgeTitle: '42ler',
      badgeText: 'Guided by scientific research and veterinary expertise, we create formulas tailored to the unique biological needs of pets and provide reliable solutions.',
      p1: "is an innovative product group developed by 42ler Pharma, offering pharmaceutical, mineral, vitamin, and feed supplement products to maximize the health and quality of life of pet animals. Guided by scientific research and veterinary professionals, we develop formulas tailored to the unique biological needs of pets.",
      p2: "Our expert team develops our products using the latest scientific data and innovative technologies in R&D. Each product is designed to support the healthy life of pet animals and is produced in accordance with international quality standards.",
      p3: "We offer a wide range of products, from immune-boosting vitamin supplements and metabolism-supporting minerals to medications developed for special treatment conditions. We adopt ethical and sustainable approaches in all our production processes, prioritizing animal welfare.",
      p4: "Our goal at Vitanimal is to ensure that pet animals live healthy, happy, and energetic lives, and to strengthen the bond between pets and their owners by offering reliable products. In the light of science and with respect for nature's balance, we continue to provide the best for all pets.",
    },
    footer: {
      tagline: 'Formulated with veterinary science',
      social: 'Social',
      contact: 'contact',
      quickLinks: 'Quick Links',
      home: 'Home',
      about: 'About Us',
      products: 'Products',
      contactLink: 'Contact',
      privacy: 'Privacy Policy',
      terms: 'Disclaimer',
    },
    contact: {
      hours: 'Working Hours',
      hoursVal: 'Monday-Friday: 08:00 - 19:00',
      email: 'Email',
      call: 'Call Us',
      formTitle: 'Have a Question?',
      formDesc: 'Our expert team is ready to answer your questions. Do not hesitate to reach us.',
      namePlaceholder: 'Your Name',
      emailPlaceholder: 'Your Email Address',
      phonePlaceholder: 'Your Phone Number',
      subjectPlaceholder: 'Subject',
      messagePlaceholder: 'Your Message',
      submitBtn: 'Send Message',
      nameReq: 'Name field is required.',
      emailReq: 'Email address cannot be empty.',
      emailInvalid: 'Invalid email format.',
      phoneReq: 'Phone number is required.',
      subjectReq: 'Please enter a subject.',
      messageReq: 'Please write your message here.',
      success: 'Your message has been sent successfully!',
      error: 'An error occurred while sending the message. Please try again.',
    },
    product: {
      backBtn: 'Back to All Products',
      whatsapp: 'Get Info via WhatsApp',
      brand: 'Brand:',
      size: 'Size:',
      tabFeatures: 'Product Specifications',
      tabUsage: 'Directions for Use',
      tabPdf: 'Product Data Sheet',
      composition: 'Composition',
      ingredients: 'Active Ingredients & Mechanisms of Action',
      usageArea: 'Indications',
      usageInstructions: 'Directions for Use',
      dosage: 'Dosage & Administration',
      storage: 'Storage Conditions',
      noUsage: 'For directions for use, refer to the product label or consult your veterinarian.',
      whatsappMsg: 'Hello, I would like to request information about the {title} product.',
    },
    pages: {
      about: 'About Us',
      products: 'Products',
      forms: 'Info Forms',
      contact: 'Contact',
      home: 'Home',
      privacy: 'Privacy Policy',
      terms: 'Disclaimer',
    },
    error404: {
      title: 'Oops! Page Not Found!',
      desc: "Sorry, we couldn't find the page you were looking for. You may have mistyped the address.",
      btn: 'Back to Home',
    },
    funfact: {
      products: 'Products',
      customers: 'Happy Clients',
      team: 'Team Members',
      protection: 'Efficacy Rate',
      customersUnit: 'k',
    },
    shop: {
      viewDetail: 'View Details',
    },
    forms: {
      viewPdf: 'View PDF',
    },
    terms: {
      title: 'Disclaimer',
      h1: 'Informational Content',
      p1: 'The information provided on this website is for general informational and educational purposes only. It is recommended to consult a veterinarian when making decisions about the use of pet nutritional supplements. Product descriptions on this site are not intended to diagnose, treat, or prevent any disease.',
      h2: 'Product Usage and Effects',
      p2: 'The effects of nutritional supplements sold may vary for each animal. Before using the products, read the instructions on the product carefully and adhere to the recommended dosages. All responsibility for any adverse events resulting from product use belongs to the user.',
      h3: 'Does Not Replace Veterinary Advice',
      p3: 'The content and products on this site do not replace professional veterinary advice. Always consult a veterinarian to make the right decisions about your pet’s specific health condition.',
      h4: 'Third-Party Information and Products',
      p4: 'The products offered on our website are provided by third-party manufacturers. Although care is taken regarding the quality and reliability of the products, no liability is accepted for any problem under the responsibility of the manufacturers.',
      h5: 'Limitation of Liability',
      p5: 'By using our website, you agree that all responsibility regarding the use of products belongs to you. The website owner cannot be held liable for misuse of products, unexpected effects, or any damages.',
      h6: 'Legal Warnings',
      p6: 'Products sold on this site are offered in accordance with local regulations. It is your responsibility to comply with the laws in your region regarding the import or use of the products.',
    },
    privacy: {
      title: 'Privacy Policy',
      h1: '1. Information Collected',
      p1_1: 'Personal Information: Information that may be collected from customers such as name, surname, email address, phone number, and delivery address.',
      p1_2: 'Automatically Collected Information: Data regarding website usage such as IP address, browser type, pages visited, duration, and dates of visit.',
      h2: '2. Use of Information',
      p2: 'Collected personal data can be used for the following purposes:',
      li2_1: 'Processing and delivery of orders.',
      li2_2: 'Providing customer support.',
      li2_3: 'Improving and personalizing the website.',
      li2_4: 'Fulfilling legal obligations.',
      li2_5: 'Marketing and promotional activities when customer consent is obtained.',
      h3: '3. Cookies',
      p3: 'Our website may use cookies to enhance the user experience. Users can control and manage the use of cookies through their browser settings.',
      h4: '4. Information Sharing',
      p4: 'Personal information will not be shared with third parties except in the following cases:',
      li4_1: 'Legal obligations.',
      li4_2: 'When necessary to carry out business processes with service providers (e.g., payment processors, logistics companies).',
      li4_3: 'When explicit consent is obtained from the user.',
      h5: '5. Protection of Information',
      p5: 'Appropriate technical and administrative measures are taken for the security of personal data. However, data transmission over the internet cannot be guaranteed to be completely secure.',
      h6: '6. Links to Other Websites',
      p6: 'Our website may contain links to other sites. We are not responsible for the privacy practices of these sites.',
      h7: '7. Children\'s Privacy',
      p7: 'Our services are not directed to children under 13, and we do not knowingly collect personal information from children.',
      h8: '8. Policy Changes',
      p8: 'Changes to the privacy policy will be updated on this page. We recommend that users periodically review the policy.',
      h9: '9. Contact',
      p9: 'If you have any questions about this privacy policy, please contact us at info@vitanimal.com.tr',
    },
  },
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState('tr');

  const t = (key) => {
    const keys = key.split('.');
    let val = translations[lang];
    for (const k of keys) {
      if (val && val[k] !== undefined) val = val[k];
      else {
        let fallback = translations['tr'];
        for (const fk of keys) {
          if (fallback && fallback[fk] !== undefined) fallback = fallback[fk];
          else return key;
        }
        return fallback;
      }
    }
    return val;
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
